<div id="forgot-password" fxLayout="column" fusePerfectScrollbar>

  <div id="forgot-password-form-wrapper" fxLayout="column" fxLayoutAlign="center center" *fuseIfOnDom [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

    <div id="forgot-password-form">

      <div class="logo">
        <img src="../assets/images/newLogo.png">
      </div>

      <div class="title">PASSWORT ERHALTEN</div>

      <form name="forgotPasswordForm" [formGroup]="forgotPasswordForm" novalidate>

        <mat-form-field>
          <input matInput placeholder="Email" formControlName="email">
          @if (forgotPasswordFormErrors.email.required) {
            <mat-error>
              Email is required
            </mat-error>
          }
          @if (!forgotPasswordFormErrors.email.required && forgotPasswordFormErrors.email.email) {
            <mat-error>
              Please enter a valid email address
            </mat-error>
          }
        </mat-form-field>

        <button mat-raised-button class="submit-button" color="accent" (click)="resetPass()"
          aria-label="SEND RESET LINK" [disabled]="forgotPasswordForm.invalid">
          RESET-LINK SENDEN
        </button>
      </form>

      <div class="login" fxLayout="row" fxLayoutAlign="center center">
        <a class="link" [routerLink]="'/pages/auth/login'">Gehen Sie zurück zum Login</a>
      </div>

    </div>

  </div>

</div>
